import React from "react";
import { Helmet } from "react-helmet";

function SeoManager({
  pageTitle = "Book Sports Venue, Events, Coaches & Academies Online | KheloMore",

  socialTitle = "Book Sports Venue, Coaches & Academies Online | KheloMore",

  socialDescription = "Book sports venues, coaching, and events with KheloMore. Explore courts, turfs, and play zones near you. Enjoy easy booking, great offers, and expert coaching!",

  description = "Book sports venues, coaching, and events with KheloMore. Explore courts, turfs, and play zones near you. Enjoy easy booking, great offers, and expert coaching!",

  keyWords = "sports venues in India, sports coaches in India, sports academies in India, sports coaching in India, sports classes in India",

  image = "https://s3.ap-south-1.amazonaws.com/khelomore-images/home/HomeOg.jpg",

  baseURL = "https://www.khelomore.com/",

  twitterTitle = "Largest sports ecosystem in India",

  twitterDescription = "Largest sports ecosystem in India. Book sports venues, academies and coaches.",

  twitterImage = "https://pbs.twimg.com/profile_images/1848302627966390272/iVzRCqty.jpg",

  twitterSite = "@KheloMore",
}) {
  return (
    <Helmet>
      <meta charSet="utf-8" />

      <link rel="canonical" href={window?.location?.href} />

      {/* Title */}
      <title>{pageTitle}</title>

      {/* SEO */}
      <meta name="description" content={description} />
      <meta name="keywords" content={keyWords} />
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={socialTitle || pageTitle} />
      <meta property="og:description" content={socialDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:image:url" content={image} />
      <meta property="og:url" content={window?.location?.href || baseURL} />
      <meta property="og:site_name" content="Khelomore" />
      <meta property="og:locale" content="En" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={twitterSite} />
      <meta name="twitter:title" content={twitterTitle || pageTitle} />
      <meta
        name="twitter:description"
        content={twitterDescription || description}
      />
      <meta name="twitter:image" content={twitterImage || image} />
    </Helmet>
  );
}

export default SeoManager;
